module.exports = __webpack_public_path__ + "media/images/icons/outlined/google-plus-739897eb813ed3e23dcdc7d4a7c59e7b.svg";